import { QueryClient } from 'react-query';
import { IClickToCallMeData } from '@vfit/shared/models';
import { IClickToCallConfigurations, ITrackError, AppMobile } from '@vfit/shared/data-access';

const isURL = (str: string) => {
  try {
    new URL(str);
    return true;
  } catch (_) {
    return false;
  }
};

const getProductCategory = (offerType: string) => {
  switch (offerType) {
    case '2':
    case 'fixed':
      return 'fixed';
    case '3':
    case 'mobile':
      return 'mobile';
    case '8':
    case 'adv':
      return 'adv';
    case '9':
    case 'energy':
      return 'energy';
    default:
      return '';
  }
};

const getCtcSunriseTemplate = (templateKey?: string, queryClient?: QueryClient) => {
  const cmsVolaTemplates = queryClient.getQueryData('getVolaTemplates');
  return (cmsVolaTemplates?.[templateKey] || {}) as IClickToCallMeData;
};

const getClickToCallUrl = (
  ctcConfiguration: IClickToCallConfigurations,
  product?,
  step?: string,
  error?: ITrackError
): string => {
  let clickToCallUrl;
  try {
    clickToCallUrl = new URL(ctcConfiguration?.url);
  } catch (e) {
    return '';
  }
  const { description: forcedDescription } = ctcConfiguration;
  const isOverrideDesc = ctcConfiguration?.overrideDesc === 'true';

  if (isOverrideDesc) {
    const env = AppMobile.checkIsApp() ? 'app' : 'web';
    const icmp = new URLSearchParams(location?.search).get('icmp');
    const sessionIcmp = sessionStorage?.getItem('icmp');
    const userType = 'NEXT';
    const origin = icmp || sessionIcmp ? 'ADV' : 'ORG';
    const pathname = location?.pathname?.replace(/^\//, '').replace(/\//g, '-');
    const fullPathname = step
      ? `${pathname}-${step.replace(/^\//, '').replace(/\//g, '-')}`
      : pathname;
    let autoUrl = `${env}_${
      icmp || sessionIcmp || 'landing-page'
    }_${userType}_${origin}_${fullPathname}`;

    const concatenatedError = [
      error?.error?.url || '',
      error?.error?.status || '',
      error?.errorType || '',
      error?.errorCode || '',
    ]
      .filter(Boolean)
      .join('_');

    if (error?.errorCode || error?.error?.status) {
      autoUrl = `${autoUrl}-error-${concatenatedError}`;
    }
    if (product) {
      const productName = product?.title?.replace(/\s+/g, '-');
      const productId = product?.offerId;
      const productPrice = product?.price?.replace(/[^0-9,]/g, '').replace(',', '');
      autoUrl = `${autoUrl}_${productName}_${productId}_${productPrice}`;
    }

    if (forcedDescription) {
      autoUrl = `${autoUrl}_${forcedDescription.replace(/\s+/g, '-')}`;
    }

    clickToCallUrl.searchParams.set('DESC', autoUrl);
  }

  return clickToCallUrl.toString() || '';
};

export { isURL, getProductCategory, getCtcSunriseTemplate, getClickToCallUrl };

